import axios from 'axios'

// 基础 axios 实例（开发默认走 /api 代理，生产由环境变量覆盖）
const http = axios.create({
  // baseURL: process.env.VUE_APP_API_BASE || '',
  baseURL: '',
  timeout: 30000, // 增加超时时间到30秒
  withCredentials: false
})

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 在此处注入 token 等
    // const token = localStorage.getItem('token')
    // if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
http.interceptors.response.use(
  response => {
    // 默认返回 data，若需要完整响应可直接返回 response
    return response.data
  },
  error => {
    // 可根据 error.response?.status 做统一错误处理
    return Promise.reject(error)
  }
)

export default http
